module.exports = __webpack_public_path__ + "static/media/neva-feature.b30e300b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva-feature.png
// module id = 339
// module chunks = 0